import React from 'react'
import Button from '@bt-react/components/Button'
import Icon, { IconType } from '@bt-react/components/Icon'
import Thumbnail from '@bt-react/components/Thumbnail'
import styles from './PlayInListItem.module.scss'
import Truncate from 'react-truncate'
import formatDuration from '@bt-react/libs/formatDuration'
import { PlayInListItemProps } from './PlayInListItemTypes'

class PlayInListItem extends React.PureComponent<PlayInListItemProps> {

  addVideo = () => {

    this.props.onAddClick(this.props.item.id)

  }

  onRemoveClick = () => {

    if (this.props.onRemoveClick) this.props.onRemoveClick(this.props.item.id)

  }

  removeButton = () => {

    return <div className={styles['button-wrapper']}>
      <Button
        dataBdd='playin-list-item-remove-button'
        color={IconType.colour.secondary}
        text="Remove"
        onClick={this.onRemoveClick}
      />
    </div>

  }

  render () {

    const { item } = this.props

    return <div
      className={styles['add-playin-list-item']}
      data-bdd={this.props.dataBdd || 'playin-list-item'}
      style={this.props.style}
    >
      <Thumbnail
        className={styles['preview-image']}
        src={item.previewImage}
        alt={item.title}
      />
      <div className={styles['details']}>
        <div className={styles['title']} data-bdd="playin-list-item-title">
          <Truncate lines={2} >
            {item.title}
          </Truncate>
        </div>
        <div className={styles['presenters']} data-bdd="playin-list-item-presenters">
          <Truncate lines={1} >
            {item.presenter}
          </Truncate>
        </div>
        <div className={styles['schedule']}>
          <span className={styles['play-box']}>
            <Icon
              name={IconType.iconName.play}
              className={styles['play-in-list-item-icon']}
            />
          </span>
          <span className={styles['times']} data-bdd="playin-list-item-times">
            {item.closeTimeFormatted}
            ,&nbsp;
            {formatDuration(item.duration)}
          </span>
        </div>
      </div>
      {this.props.showAddButton &&
        <div className={styles['button-wrapper']} data-bdd="playin-list-item-add-button">
          { !this.props.isVideoAdded
            ? <Button color={IconType.colour.secondary} text="Add" onClick={this.addVideo} />
            : <span className={styles['added']}>Added</span>
          }
        </div>
      }
      {this.props.showRemoveButton && this.removeButton()}
    </div>

  }

}

export default PlayInListItem
